import { render } from "./InstitutionAEModal.vue?vue&type=template&id=413ed92f&ts=true"
import script from "./InstitutionAEModal.vue?vue&type=script&lang=ts"
export * from "./InstitutionAEModal.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__